import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  TransactionOutlined,
  BankOutlined,
  WalletOutlined,
  LogoutOutlined,
  HeartFilled,
  IdcardOutlined,
  TrophyOutlined,
  CrownOutlined ,
} from "@ant-design/icons";
import { UserGet } from "../../../Api/CoreApi";
import "./StaffSidebar.css";

function StaffSidebar({ isOpen, isMobile, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const staffName = localStorage.getItem("username") || "Staff Member";
  const staffId = localStorage.getItem("user_id") || "0001";
  
  // ✅ State for Profile ID
  const [staffProfileId, setStaffProfileId] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch staff profile ID
  useEffect(() => {
    const fetchStaffProfile = async () => {
      try {
        const users = await UserGet();
        if (Array.isArray(users)) {
          const currentStaff = users.find(u => String(u.id) === String(staffId));
          if (currentStaff && currentStaff.profile_id) {
            setStaffProfileId(currentStaff.profile_id);
            console.log('✅ Staff Profile ID loaded:', currentStaff.profile_id);
          }
        }
      } catch (error) {
        console.error('❌ Error fetching staff profile:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStaffProfile();
  }, [staffId]);

  const handleLogout = () => {
    localStorage.clear();
    message.success("Logged out successfully");
    navigate("/Staff_Login");
  };

  const menuItems = [
    { icon: <DashboardOutlined />, label: "Dashboard", path: "/Staff_Panel" },
    { icon: <UserOutlined />, label: "User", path: "/staff/users" },
    { icon: <CrownOutlined />, label: "Premium Members", path: "/staff/premium-members" },
    { icon: <TransactionOutlined />, label: "Transaction", path: "/staff/transactions" },
    { icon: <BankOutlined />, label: "Staff Bank", path: "/staff/bank" },
    { icon: <WalletOutlined />, label: "Withdrawal", path: "/staff/withdrawals" },
    { icon: <TrophyOutlined />, label: "Success Stories", path: "/staff/success-stories" },
  ];

  // ✅ Display Profile ID or fallback
  const displayProfileId = staffProfileId || `CRST${String(staffId).padStart(6, '0')}`;

  return (
    <aside className={`staff-sidebar ${isOpen ? "open" : "closed"}`}>

      {/* Logo */}
      <div className="staff-sidebar-logo">
        <div className="staff-logo-icon"><HeartFilled /></div>
        <div className="staff-logo-text">
          <h2>Matrimonial</h2>
          <p>Staff Panel</p>
        </div>
      </div>

      {/* Staff Profile Mini Card */}
      <div className="staff-sidebar-profile">
        <div className="staff-profile-avatar">
          {staffName.charAt(0).toUpperCase()}
        </div>
        <div className="staff-profile-info">
          <div className="staff-profile-name">{staffName}</div>
          {/* ✅ Profile ID - Updated */}
          <div className="staff-profile-id">
            <IdcardOutlined /> {displayProfileId}
          </div>
          <div className="staff-profile-role">Matchmaker Staff</div>
        </div>
      </div>

      {/* Menu */}
      <nav className="staff-sidebar-nav">
        <ul className="staff-sidebar-menu">
          {menuItems.map((item, idx) => (
            <li key={idx}>
              <Link
                to={item.path}
                className={`staff-menu-item ${isActive(item.path) ? "active" : ""}`}
                onClick={() => isMobile && onClose()}
              >
                <span className="staff-menu-icon">{item.icon}</span>
                <span className="staff-menu-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Logout */}
      <div className="staff-sidebar-logout">
        <button className="staff-logout-btn" onClick={handleLogout}>
          <LogoutOutlined />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default StaffSidebar;